import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionPlanEmailTemplates } from "./email-templates";
import { HeaderInner } from "./email-templates/_shared/components/header-inner";

import type { PlanI18nCategoriesAndManagerStore } from "../../store/categories";

type Props = {
	email: PlanI18nCategoriesAndManagerStore["email"];
	hotelID: string;
	planID: string;
	hotelEmailAddress: string;
};

export const QuestionPlanEmail = ({ email, hotelID, planID, hotelEmailAddress }: Props) => {
	return (
		<>
			<FeatureIslandMainWithCategoryWrapper islandTitle="メール設定" categoryStore={email}>
				<HeaderInner hotelID={hotelID} planID={planID} />
			</FeatureIslandMainWithCategoryWrapper>
			<QuestionPlanEmailTemplates email={email} hotelEmailAddress={hotelEmailAddress} />
		</>
	);
};

QuestionPlanEmail.displayName = "QuestionPlanEmail";
